import React, { useEffect, useState } from "react"
import {
  nePasManquerContainer,
  nePasManquerTitle,
  nePasManquerResume,
  nePasManquerItemFirst,
  autresNePasManquer,
  editButtonTitle,
} from "./ne-pas-manquer.module.scss"
import PropTypes from "prop-types"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import NePasManquerItem from "./NePasManquerItem/ne-pas-manquer-item"
import { Title } from "./ne-pas-manquer-styled"
import { useNePasManquer } from "gatsby-theme-blank/src/components/Home/NePasManquer/ne-pas-manquer-query"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
//-----------------------Parent component---------------------------//

const ListNePasManquer = () => {
  const data = useNePasManquer()
  const [finalData, setFinalData] = useState([])

  useEffect(() => {
    setFinalData(getPublishedData(data.allNodePage.edges))
  }, [data])

  if (finalData.length === 0) {
    return null
  }
  return (
    <>
      <Title className={nePasManquerTitle}>
        <EditButton
          addedClass={editButtonTitle}
          link={
            "/taxonomy/term/" +
            data.taxonomyTermZoneDefinie.drupal_internal__tid +
            "/edit"
          }
        />
        {data.taxonomyTermZoneDefinie?.field_label || "À ne pas manquer"}
      </Title>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={nePasManquerResume}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={nePasManquerContainer}>
        <RenderNePasManquer nePasManquerData={finalData} />
      </div>
    </>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const RenderNePasManquer = ({ nePasManquerData }) => {
  const firstNePasManquer = nePasManquerData[0].node
  return (
    <>
      <div className={nePasManquerItemFirst}>
        <NePasManquerItem nePasManquer={firstNePasManquer} />
      </div>
      <div className={autresNePasManquer} role={"list"}>
        {nePasManquerData.slice(1).map(({ node }) => {
          return (
            <NePasManquerItem
              key={node.drupal_id}
              nePasManquer={node}
              role={"listitem"}
            />
          )
        })}
      </div>
    </>
  )
}

//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

RenderNePasManquer.propTypes = {
  nePasManquerData: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default ListNePasManquer
